import React , {useState, useEffect} from 'react';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import { homeObjOne, homeObjTwo} from '../components/InfoSection/Data';
import Navbar from '../components/Navbar';
import Services from '../components/Services';
import Sidebar from '../components/Sidebar';
import ScrollToTop from '../components/ScrollToTop';

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  }

  const [isDesktop, setDesktop] = useState(window.innerWidth > 768);

  const updateMedia = () => {
    setDesktop(window.innerWidth > 768);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  return (
    <>
      <ScrollToTop />
      <Sidebar  isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroSection isDesktop = {isDesktop}/>
      <InfoSection {...homeObjOne}/>
      <Services isDesktop = {isDesktop}/>
      <InfoSection {...homeObjTwo}/>
      <Footer />
    </>
  );
};

export default Home;